import { render, staticRenderFns } from "./NotFoundOrganization.vue?vue&type=template&id=f24f5e34&"
import script from "./NotFoundOrganization.vue?vue&type=script&lang=js&"
export * from "./NotFoundOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f24f5e34')) {
      api.createRecord('f24f5e34', component.options)
    } else {
      api.reload('f24f5e34', component.options)
    }
    module.hot.accept("./NotFoundOrganization.vue?vue&type=template&id=f24f5e34&", function () {
      api.rerender('f24f5e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotFoundOrganization.vue"
export default component.exports